import classNames from "classnames";
import { forwardRef } from "react";
import styles from "./index.module.less";
/**
 * 输入框包装
 * @param {{
 *    placeholder: String,
 *    isFocus: Boolean,
 *    isFilled: Boolean
 * }} props
 * @returns {Function}
 */
function WrapRaw(props, ref) {
  const {
    placeholder,
    isFocus = false,
    isFilled = false,
    isDisabled = false,
    noWrapper = false,
    className,
  } = props;

  return (
    <div
      ref={ref}
      className={classNames([
        styles.wrap,
        className,
        noWrapper ? styles.nowrap : null,
        isFocus ? styles.focus : null,
        isFilled ? styles.filled : null,
        isDisabled ? styles.disabled : null,
      ])}
      data-placeholder={placeholder}
    >
      {props.children}
    </div>
  );
}

const Wrap = forwardRef(WrapRaw);
export default Wrap;
